// Matches html/body font-size in tailwind.css. The fallback used to be 1, which
// made every rem->px conversion 11x too small on the whole SSR pass.
const ROOT_FONT_SIZE_PX = 11;

export const getRootFontSize = () => {
    try {
        if (typeof window === 'undefined') {
            return ROOT_FONT_SIZE_PX;
        }

        const pixelString = window.getComputedStyle(document.body).getPropertyValue('font-size');
        const pixelValue = parseInt(pixelString.replace('px', ''));

        return Number.isFinite(pixelValue) && pixelValue > 0 ? pixelValue : ROOT_FONT_SIZE_PX;
    } catch (err) {
        return ROOT_FONT_SIZE_PX;
    }
};

export const convertRemToPixel = (rem: number) => {    
    return rem * getRootFontSize();
};

export const convertPixelToRem = (px: number) => {
    const pixels = px / getRootFontSize();
    const rounded = Math.round(pixels * 100) / 100;
    
    return rounded;
};